import {
    listInputs,
    listOutputs
} from "./MidiController";
import { NoteActivityObserver } from "./NoteActivity";
import { RydMidiAccess } from "../stores/MidiAccessStore";
import { RydInstrument } from "../model/instrument";
import {
    TrackOutputType,
    TrackSourceType
} from "../model/tracks";
import {
    RydInputSource,
    RydManualInputSource
} from "./input";


type AudioSink = {
    displayName: string;
    id: string;
    type: TrackOutputType;
}

type AudioSource = {
    displayName: string;
    id: string;
    type: TrackSourceType;
}

class MidiSink implements AudioSink {
    constructor(public displayName: string, public id: string, public type: TrackOutputType) { }
}
class MidiSource implements AudioSource {
    constructor(public displayName: string, public id: string, public type: TrackSourceType) { }
}

const MANUAL_NOTE_INPUT = new RydManualInputSource();
function getDefaulAudioSource(): RydInputSource {
    return MANUAL_NOTE_INPUT;
}

function listAudioSinks(midiAccess: RydMidiAccess): AudioSink[] {
    return listOutputs(midiAccess).map((output) => new MidiSink(output.name, output.id, 'EXTMIDI'));
}

function listAudioSources(midiAccess: RydMidiAccess): AudioSource[] {
    return listInputs(midiAccess).map((input) => new MidiSource(input.name, input.id, 'MIDIIN'));
}

class AudioEventRouter {
    private audioSink?: AudioSink;
    private audioSource: AudioSource;
    private noteActivityObserver: NoteActivityObserver;
    private instrument?: RydInstrument;

    constructor(audioSource: AudioSource, audioSink?: AudioSink) {
        this.audioSink = audioSink;
        this.audioSource = audioSource;
        this.noteActivityObserver = NoteActivityObserver.getInstance();
    }

    setAudioSink(sink: AudioSink) {
        this.audioSink = sink;
    }

    getAudioSink(): AudioSink | undefined {
        return this.audioSink;
    }

    setAudioSource(source: AudioSource) {
        this.audioSource = source;
    }

    getAudioSource(): AudioSource {
        return this.audioSource;
    }

    setInstrument(instrument?: RydInstrument) {
        this.instrument = instrument;
    }
}

export {
    AudioSink,
    MidiSink,
    MidiSource,
    listAudioSinks,
    getDefaulAudioSource,
    AudioSource,
    listAudioSources,
    AudioEventRouter
};